import { RouteConfig } from 'vue-router';

const AdminView = () => import('@/views/admin.vue');
const AdminViewIndex = () => import('@/views/admin/index.vue');
const TaxPayersViewIndex = () =>
  import('@/views/admin/tax-payers/index.vue');

export default {
  path: '/admin',
  component: AdminView,
  meta: {
    name: 'page.admin',
  },
  children: [
    {
      path: '',
      name: 'admin-index',
      redirect: { name: 'admin-taxpayers-index' },
      component: AdminViewIndex,
    },
    {
      path: 'taxpayers',
      component: TaxPayersViewIndex,
      name: 'admin-taxpayers-index',
      meta: {
        name: 'section.taxPayers',
      },
    },
  ],
} as RouteConfig;
